interface IConfiguration {
	maxLengthDepotHeader: number;
	maxLinesDepotHeader: number;
	maxLengthLabel: number;
	maxLengthAccessPoint: number;
	minLengthAccessPoint: number;
	maxLengthDescription: number;
	maxLengthExpoMetadataTitleDisplay: number;
	maxLengthExpoMetadataDescriptionDisplay: number;
	maxLengthExpoEndpointMetadataTitleDisplay: number;
	maxLengthExpoEndpointMetadataDetailsDisplay: number;
}

export const configuration: IConfiguration = {
	maxLengthDepotHeader: 40,
	maxLinesDepotHeader: 1,
	maxLengthLabel: 256,
	maxLengthAccessPoint: 50,
	minLengthAccessPoint: 4,
	maxLengthDescription: 2500,
	maxLengthExpoMetadataTitleDisplay: 50,
	maxLengthExpoMetadataDescriptionDisplay: 250,
	maxLengthExpoEndpointMetadataTitleDisplay: 120,
	maxLengthExpoEndpointMetadataDetailsDisplay: 400,
};
